// extracted by mini-css-extract-plugin
export default {"srOnly":"VisuallyHidden-VisuallyHidden-module__srOnly--e4svh"};